import React from 'react'
import Spinner from "../../Component/Loader";

export default function Index() {
	return (
		<div className='d-flex align-items-center justify-content-center w-100 bg-white' style={{height: '100vh'}}>
			<Spinner radius={36} visible={true} color="var(--primary-color)"/>
		</div>
	)
}